var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3.167 3.167v9.666H4.5v-3.5a.5.5 0 01.5-.5h6a.5.5 0 01.5.5v3.5h1.333v-7.96l-1.707-1.706H10.5v2.5a.5.5 0 01-.5.5H5a.5.5 0 01-.5-.5v-2.5H3.167zm2.333 0v2h4v-2h-4zm5 9.666v-3h-5v3h5zM2.167 3c0-.46.373-.833.833-.833h8.333a.5.5 0 01.354.146l2 2a.5.5 0 01.146.354V13c0 .46-.373.833-.833.833H3A.833.833 0 012.167 13V3z"
  })));
}
export default SvgSaveIcon;